import { render, staticRenderFns } from "./tree.vue?vue&type=template&id=0a9d7cb2&scoped=true&"
import script from "./tree.vue?vue&type=script&lang=ts&"
export * from "./tree.vue?vue&type=script&lang=ts&"
import style0 from "./tree.vue?vue&type=style&index=0&id=0a9d7cb2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a9d7cb2",
  null
  
)

export default component.exports